import { getStaticImage } from 'utils/statics'

/**
 * Get toast icon and alt
 * @param {string} statusType
 *
 * @returns {{url: string, description: string}|null}
 */
export const getNotificationIcon = (statusType) => {
  if (statusType === 'ok') {
    return {
      url: getStaticImage('/icons/orange-brand/icon-tick-secondary-dark.svg'),
      description: 'Success'
    }
  }

  if (statusType === 'error') {
    return {
      url: getStaticImage('/icons/orange-brand/icon-close-slim-red.svg'),
      description: 'Error'
    }
  }

  return null
}

/**
 * Get class for styles
 * @param {object} params
 * @param {string} [params.statusType]
 * @param {string} [params.customClass]
 *
 * @returns {string}
 */
export const getClassNames = (params = {}) => {
  const { statusType , customClass } = params

  let className = ''
  if (statusType) className += ` toast-notification-status--${statusType}`
  if (customClass) className += ` ${customClass}`

  return className
}
